<template>
    <div>
      <h3>Contact information</h3>
      <p>This page is currently under reconstruction</p>
      <br><br>
    </div>  
</template>

<script>
</script>